import styled from 'styled-components'

import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: contents;
  }
`
export const ImageContainer = styled.div`
  width: 350px;
  height: 100%;
  padding-bottom: 30px;
  margin: 0 auto;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`
export const TextItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`

export const TextItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`
export const ImageIcon = styled.div`
  display: flex;
  margin-right: 16px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-right: 10px;
  }
`

export const Title = styled(Heading2)`
  color: ${style(theme => theme.colors.slate)};
  font-size: 22px;
  font-weight: 600;
  height: 30px;
  letter-spacing: 0px;
  line-height: 30px;
  text-align: center;
  max-width: 450px;
  margin: auto;
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    display: contents;
  }
`
export const SubscriptionSubText = styled.div`
  color: ${style(theme => theme.colors.green)};
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  justify-content: center;
  margin: 10px 0 50px;
  text-align: center;
`
export const SubscriptionText = styled.div`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  max-width: 450px;
  margin: 10px auto 15px;
  text-align: center;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: 250px;
    height: 100%;
  }
`

export const Text = styled.div`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  line-height: 22px;
  width: 300px;
  margin: 0;
  display: inline;
`

export const LaterText = styled(Body)`
  margin-bottom: 80px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    margin-bottom: 80px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 60px;
  }
`
export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
`

export const MenuContainer = styled.div`
  display: flex;
  margin: 0 auto;
  padding-bottom: 60px;
  position: relative;
  justify-content: center;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 30px;
  }
`

export const MenuItem = styled.div`
  width: 300px;
  border-radius: 10px;
  border: 1px solid ${style(theme => theme.colors.ivory)};
  display: flex;
  padding: 10px;
  font-size: 14px;
  align-items: center;
  color: ${style(theme => theme.colors.slate)};
`

export const FloatingHeader = styled.span`
  font-size: 14px;
  font-weight: 600;
  z-index: 1;
  position: absolute;
  top: -8px;
  width: 100%;
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0);
`

export const Header = styled.div`
  background: white;
`
